// extracted by mini-css-extract-plugin
module.exports = {"container":"DatePicker__container___3S68r","label":"DatePicker__label___3e5Ox"};